<template>
  <v-card
    flat
    class="pa-0 ma-0"
  >
    <v-chip
      v-if="show && price"
      class="ma-2 text-h6"
      outlined
      large
    >
      <v-icon left>
        {{ currencyIcon }}
      </v-icon>
      {{ price }}
    </v-chip>
    <div
      v-if="show && shippingMessage"
      class="pa-0 ma-0 text-caption"
    >
      {{ shippingMessage }}
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean
    },
    currencyIcon: {
      type: String,
      default: ()=>null
    },
    price: {
      type: String,
      default: ()=>null
    },
    shipping: {
      type: Object,
      default: ()=>{return {}}
    }
  },
  computed: {
    shippingMessage() {
      if (this.shipping.kind == 'free') {
        return 'FREE Shipping'
      } else if (this.shipping.kind == 'flatrate' && this.shipping.flatrate) {
        return `+ ${this.shipping.flatrate.cost} Shipping`
      }
      return false
    }
  },
}
</script>